var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11C22 9.65451 21.758 8.36557 21.3158 7.17396L11 6.69568L0.684191 7.17392C0.242043 8.36557 0 9.65451 0 11C0 12.3456 0.242043 13.6345 0.684191 14.8261L11 15.3044L21.3158 14.8261C21.758 13.6345 22 12.3456 22 11Z",
    fill: "#0052B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 22C15.7295 22 19.7615 19.0149 21.3157 14.826H0.684082C2.2383 19.0149 6.27028 22 10.9999 22Z",
    fill: "#FF9811"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.684082 7.17393H21.3157C19.7615 2.98513 15.7295 0 10.9999 0C6.27028 0 2.2383 2.98513 0.684082 7.17393Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArm);
export default __webpack_public_path__ + "static/media/arm.ef716d1c51fa826645674f71b6cb8c87.svg";
export { ForwardRef as ReactComponent };